import { render, staticRenderFns } from "./ReplaceDataEffect.vue?vue&type=template&id=1b7012b7&"
import script from "./ReplaceDataEffect.vue?vue&type=script&lang=ts&"
export * from "./ReplaceDataEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports